/*
 * price-per-day.js — v3, 27 Mar 2026
 * Calculates per-day price on product page and collection cards.
 * Recalculates on variant (pill) switch.
 * v3: normalise kg/g units to avoid day-supply miscalculation across mixed-unit variants.
 */
(function() {

  function parseNumber(text) {
    if (!text) return NaN;
    var match = text.match(/[\d,.]+/);
    if (!match) return NaN;
    var num = match[0].replace(/,/g, '.');
    var parts = num.split('.');
    if (parts.length > 2) {
      num = parts.slice(0, -1).join('') + '.' + parts[parts.length - 1];
    }
    return parseFloat(num);
  }

  // Normalise any weight text to grams for consistent cross-unit comparison
  function toGrams(text) {
    if (!text) return NaN;
    var num = parseNumber(text);
    if (isNaN(num)) return NaN;
    if (/kg/i.test(text)) return num * 1000;
    return num; // assume grams (or capsules — unitless quantities work the same)
  }

  function getCurrencySymbol(priceText) {
    if (!priceText) return '£';
    var match = priceText.match(/^[^\d,]+/);
    return match ? match[0].trim() : '£';
  }

  function formatPerDay(symbol, amount) {
    if (isNaN(amount) || amount <= 0) return '';
    return symbol + amount.toFixed(2);
  }

  /* -- PRODUCT PAGE -- */

  function initProductPage() {
    var dataEl = document.getElementById('variant-supply-data');
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch(e) { return; }

    var baseDaySupply = data.baseDaySupply;
    var baseSupply = data.baseSupply || '';
    if (!baseDaySupply || baseDaySupply <= 0) return;

    // Normalise base supply to grams for cross-unit ratio calculation
    var baseGrams = toGrams(baseSupply);
    var gramsPerDay = (baseGrams && baseGrams > 0) ? baseGrams / baseDaySupply : 0;

    var firstVariant = data.variants[0];
    if (!firstVariant) return;

    var currencySymbol = '£';
    if (data.currency) {
      var cMatch = data.currency.match(/^[^{]+/);
      if (cMatch) currencySymbol = cMatch[0].trim();
    }

    // Initial calculation
    var currentPrice = firstVariant.price / 100;
    var perDayEl = document.querySelector('.perDayPrice');
    if (perDayEl) {
      perDayEl.textContent = formatPerDay(currencySymbol, currentPrice / baseDaySupply);
    }

    // Listen for pill clicks
    var form = document.querySelector('[data-node-type="commerce-add-to-cart-form"]');
    if (!form) return;

    var pills = form.querySelectorAll('[data-node-type="add-to-cart-option-pill"]');
    pills.forEach(function(pill) {
      pill.addEventListener('click', function() {
        var pillText = pill.textContent.trim();
        var pillSlug = pillText.toLowerCase().replace(/\s+/g, '-');

        var variant = null;
        for (var i = 0; i < data.variants.length; i++) {
          var vSlug = (data.variants[i].option1 || '').toLowerCase().replace(/\s+/g, '-');
          if (vSlug === pillSlug) {
            variant = data.variants[i];
            break;
          }
        }
        if (!variant) return;

        var newPrice = variant.price / 100;

        // Normalise pill text to grams for correct day supply calculation
        var newGrams = toGrams(pillText);
        var newDaySupply = baseDaySupply;

        if (gramsPerDay > 0 && newGrams > 0) {
          newDaySupply = Math.round(newGrams / gramsPerDay);
        }

        // Update day supply
        var daySupplyEl = document.querySelector('.product_info_col .daySupply');
        if (daySupplyEl) daySupplyEl.textContent = newDaySupply;

        // Update supply text — use pill text directly (it IS the variant size)
        var supplyEl = document.querySelector('.supplyText');
        if (supplyEl) supplyEl.textContent = pillText;

        // Update per-day price
        if (perDayEl && newDaySupply > 0) {
          perDayEl.textContent = formatPerDay(currencySymbol, newPrice / newDaySupply);
        }
      });
    });
  }

  /* -- COLLECTION CARDS -- */

  function initCollectionCards() {
    var cards = document.querySelectorAll('.product-card');
    cards.forEach(function(card) {
      var priceEl = card.querySelector('.pricePerItem');
      var daySupplyEl = card.querySelector('.daySupply');
      var perDayEl = card.querySelector('.pricePerDay');
      if (!priceEl || !daySupplyEl || !perDayEl) return;

      var basePrice = parseNumber(priceEl.textContent);
      var baseDaySupply = parseNumber(daySupplyEl.textContent);
      var currencySymbol = getCurrencySymbol(priceEl.textContent);

      if (isNaN(basePrice) || isNaN(baseDaySupply) || baseDaySupply <= 0) return;

      // Initial per-day calc
      perDayEl.textContent = formatPerDay(currencySymbol, basePrice / baseDaySupply);

      var pills = card.querySelectorAll('[data-node-type="add-to-cart-option-pill"]');
      if (pills.length < 2) return;

      // Normalise first pill to grams for cross-unit calculation
      var baseGrams = toGrams(pills[0].textContent.trim());
      var gramsPerDay = (baseGrams > 0) ? baseGrams / baseDaySupply : 0;

      // Get variant price data
      var variantDataEl = card.querySelector('[data-type="product-variations-data"]');
      var variants = [];
      if (variantDataEl) {
        try { variants = JSON.parse(variantDataEl.textContent); } catch(e) {}
      }

      pills.forEach(function(pill, idx) {
        pill.addEventListener('click', function() {
          setTimeout(function() {
            var newPriceText = priceEl.textContent;
            var newPrice = parseNumber(newPriceText);
            var newCurrencySymbol = getCurrencySymbol(newPriceText);

            if (variants[idx] && variants[idx].price) {
              var varPrice = parseNumber(variants[idx].price);
              if (!isNaN(varPrice)) newPrice = varPrice;
              newCurrencySymbol = getCurrencySymbol(variants[idx].price);
            }

            var newGrams = toGrams(pill.textContent.trim());
            var newDaySupply = baseDaySupply;
            if (gramsPerDay > 0 && newGrams > 0) {
              newDaySupply = Math.round(newGrams / gramsPerDay);
            }

            daySupplyEl.textContent = newDaySupply;
            if (!isNaN(newPrice) && newDaySupply > 0) {
              perDayEl.textContent = formatPerDay(newCurrencySymbol, newPrice / newDaySupply);
            }
          }, 50);
        });
      });
    });
  }

  /* -- INIT -- */

  document.addEventListener('DOMContentLoaded', function() {
    initProductPage();
    initCollectionCards();
  });

})();